// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"CustomErrorMessage_errorMessage__1JkWM","error__primary":"CustomErrorMessage_error__primary__1hUPn"};